module.exports = __webpack_public_path__ + "static/media/testimonial-logos.6d3dad33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial-logos.jpg
// module id = 1426
// module chunks = 0